import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
// import { useState } from "react";
import { useEvent } from "../../../../context/EventContext";
import Modal from "react-modal"; // Importing react-modal
import { IoCloseSharp } from "react-icons/io5";

const localizer = momentLocalizer(moment); // Set up localizer with moment.js

// Setting up the modal
Modal.setAppElement("#root");

//  * Calender component to display a calendar for selecting dates
//  * and creating new sub-events.
const Calender = ({ setIsFormVisible, subEventFormData, subEvents }) => {
  const {
    setSubEventFormData,
    handleSubChange,
    formData,
    newEvent,
    view,
    setView,
    selectedDate,
    setSelectedDate,
    handleSelectSlot,
    isSubModalOpen,
    setIsSubModalOpen,
  } = useEvent();

  //   * Handles the selection of a time slot on the calendar. If the selection
  //   * is within the range of the event's start and end dates, it sets the
  //   * `newEvent` state to the selected time range and opens the modal to
  //   * create a new sub-event.

  // Handle the drill down to the selected date
  const handleDrillDown = (date) => {
    setView("day"); // Switch to day view
    setSelectedDate(date); // Set the selected date to the clicked date
  };

  const closeModal = () => {
    setIsSubModalOpen(false);
    setSubEventFormData({
      ...subEventFormData,
      title: "",
    });
  };

  //   * Returns an object that can be used to style a day in the calendar based
  //   * on whether it is within the range of the event's start and end dates.
  //   * If the date is not within the range, it adds a class of `disabled-day`
  //   * and sets the background color to a light gray, text color to gray, and
  //   * cursor to not allowed.
  const dayPropGetter = (date) => {
    if (!formData.eventDuration) return {};

    const rangeStart = new Date(formData?.eventDuration[0]?.start);
    const rangeEnd = new Date(
      formData?.eventDuration[formData?.eventDuration?.length - 1]?.end
    );

    rangeStart.setHours(0, 0, 0, 0); // Start of the first day
    rangeEnd.setHours(23, 59, 59, 999); // End of the last day

    if (date < rangeStart || date > rangeEnd) {
      return {
        className: "disabled-day",
        style: {
          backgroundColor: "#c7c5c5",
          color: "#3d3c3c",
          cursor: "not-allowed",
        },
      };
    }

    return {};
  };

  //   * Handles the "Next" button click in the modal. If the user has selected a
  //   * time range (`newEvent` is not null) and has entered a title for the sub-event
  //   * (`subEventFormData?.title` is not null or empty), it updates the
  //   * `subEventFormData` state with the title and sets `isFormVisible` to true.
  //   * This will display the sub-event form with the selected time range and title
  //   * pre-filled. It also closes the modal.
  const handleNext = () => {
    if (newEvent && subEventFormData?.title) {
      setSubEventFormData({
        ...subEventFormData,
        title: subEventFormData?.title, // Update title with user input
      });
      setIsSubModalOpen(false);
      setIsFormVisible(true);
    }
  };

  // Custom styles for the modal
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  // * Format function for the agenda view that takes in the start and end times of an event
  // * and formats them into a string with the format "hh:mm A - hh:mm A".
  const formats = {
    agendaTimeRangeFormat: ({ start, end }, culture, localizer) =>
      localizer.format(start, "hh:mm A", culture) +
      " - " +
      localizer.format(end, "hh:mm A", culture),
  };

  const handleNavigate = (newDate) => {
    setSelectedDate(newDate); // Update the selected date when the user navigates
  };

  const getEventTimeRange = () => {
    if (view === "day" && selectedDate) {
      // Find the event that matches the selected date (either start or end date)
      const matchingEvent = formData?.eventDuration.find(
        (event) =>
          new Date(event?.start).toDateString() ===
            selectedDate.toDateString() ||
          new Date(event?.end).toDateString() === selectedDate.toDateString()
      );


      // If a matching event is found, return its start and end times
      if (matchingEvent) {
        return {
          minTime: new Date(matchingEvent?.start),
          maxTime: new Date(matchingEvent?.end),
        };
      }
    }

    // Default to a full day range if no match is found
    return {
      minTime: new Date(formData?.eventDuration[0]?.start),
      maxTime: new Date(
        formData?.eventDuration[formData?.eventDuration?.length - 1]?.end
      ),
    };
  };

  const { minTime, maxTime } = getEventTimeRange();

  return (
    <>
      <Calendar
        localizer={localizer}
        events={subEvents.map((subEvent) => ({
          start: new Date(subEvent.start),
          end: new Date(subEvent.end),
          title: subEvent?.title,
        }))}
        selectable
        onSelectSlot={handleSelectSlot}
        views={["month", "week", "day", "agenda"]}
        defaultView="month"
        style={{ minHeight: "500px" }}
        formats={formats} // Custom time formatting
        dayPropGetter={dayPropGetter}
        allDay={true}
        view={view}
        date={view === "day" || view === "agenda" ? selectedDate : undefined} // Pass the selectedDate when in "day" view
        onNavigate={handleNavigate}
        onDrillDown={handleDrillDown}
        onView={(newView) => setView(newView)} // Update view when user clicks on month/week/day/agenda buttons
        // Set min and max times to 4 PM and 10 PM, respectively, for the selected day
        // min={new Date(selectedDate).setHours(16, 0, 0, 0)} // 4:00 PM
        // max={new Date(selectedDate).setHours(22, 0, 0, 0)} // 10:00 PM

        min={minTime}
        max={maxTime}
      />
      <Modal
        isOpen={isSubModalOpen}
        style={customStyles}
        overlayClassName="createEventName"
      >
        <div className="modal1">
          <h2>Create Event</h2>
          <IoCloseSharp onClick={() => closeModal()} className="close-icon" />

          {/* Event Name */}
          <label htmlFor="space-name">Event Name</label>
          <input
            name="title"
            type="text"
            placeholder="Enter the name of your event"
            value={subEventFormData?.title}
            onChange={handleSubChange}
          />
          <button className="add-space" onClick={() => handleNext()}>
            Next
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Calender;
